/**
 * c27-bloglist.js – Search / Filter / Sort for bloglist mobile only.
 * Independent from c27-journal-filters.js and c27-blog-mobile.liquid JS.
 */
(function () {
  'use strict';

  function init() {
  var root = document.querySelector('[data-c27-bloglist-mobile]');
  if (!root) return;

  var filterOpenBtn = root.querySelector('[data-c27-bloglist-filter-open]');
  var sortOpenBtn = root.querySelector('[data-c27-bloglist-sort-open]');
  var filterPopup = root.querySelector('[data-c27-bloglist-filter-popup]');
  var sortSheet = root.querySelector('[data-c27-bloglist-sort-sheet]');
  var filterBackdrop = root.querySelector('[data-c27-bloglist-filter-backdrop]');
  var sortBackdrop = root.querySelector('[data-c27-bloglist-sort-backdrop]');
  var filterCloseBtns = root.querySelectorAll('[data-c27-bloglist-filter-close]');
  var filterCancelBtn = root.querySelector('[data-c27-bloglist-filter-cancel]');
  var filterApplyBtn = root.querySelector('[data-c27-bloglist-filter-apply]');
  var filterClearBtn = root.querySelector('[data-c27-bloglist-filter-clear]');
  var clearAllBtn = root.querySelector('[data-c27-bloglist-clear-all]');
  var searchInput = root.querySelector('[data-c27-bloglist-search]');
  var chipsContainer = root.querySelector('[data-c27-bloglist-chips]');
  var filteredBlock = root.querySelector('[data-c27-bloglist-filtered]');
  var sortOptions = root.querySelectorAll('[data-c27-bloglist-sort-option]');
  var globalEmpty = root.querySelector('[data-c27-bloglist-empty]');
  var grid = root.querySelector('[data-c27-bloglist-grid]');
  var allCards = grid ? Array.from(grid.querySelectorAll('[data-c27-bloglist-card]')) : [];
  var originalOrder = allCards.slice();
  var cardsBeforeInit = allCards.length;

  var state = {
    query: '',
    categories: [],
    readtimes: [],
    tags: [],
    sort: 'default'
  };

  var initialCategory = '';
  if (root.hasAttribute('data-c27-bloglist-initial-category')) {
    initialCategory = (root.getAttribute('data-c27-bloglist-initial-category') || '').trim().toLowerCase();
  }
  if (initialCategory) {
    state.categories = [initialCategory];
  }

  var filterTimer = null;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/['']/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isFilterActive() {
    return !!(
      state.query ||
      state.categories.length ||
      state.readtimes.length ||
      state.tags.length ||
      state.sort !== 'default'
    );
  }

  function getCardTags(card) {
    return (card.dataset.tags || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
  }

  function parseCardDate(card) {
    var raw = card.dataset.date || '';
    if (/^\d+$/.test(raw)) return parseInt(raw, 10);
    var parsed = Date.parse(raw);
    return parsed ? Math.floor(parsed / 1000) : 0;
  }

  function cardMatchesCategory(card, cats) {
    if (!cats.length) return true;
    return cats.some(function (key) {
      var normalizedKey = normalize(key);
      if (!normalizedKey) return false;
      var haystacks = [
        normalize(card.dataset.categorySlug),
        normalize(card.dataset.category)
      ].concat(getCardTags(card).map(normalize));
      return haystacks.some(function (hay) {
        if (!hay) return false;
        return hay === normalizedKey || hay.indexOf(normalizedKey) >= 0 || normalizedKey.indexOf(hay) >= 0;
      });
    });
  }

  function matchesQuery(card, q) {
    if (!q) return true;
    var ql = q.toLowerCase();
    return (card.dataset.title || '').toLowerCase().indexOf(ql) >= 0 ||
      (card.dataset.excerpt || '').toLowerCase().indexOf(ql) >= 0 ||
      (card.dataset.category || '').toLowerCase().indexOf(ql) >= 0 ||
      (card.dataset.tags || '').toLowerCase().indexOf(ql) >= 0;
  }

  function matchesReadtime(card, rts) {
    if (!rts.length) return true;
    var rt = parseInt(card.dataset.readtime, 10) || 1;
    return rts.some(function (bucket) {
      if (bucket === 'under2') return rt < 2;
      if (bucket === '2to5') return rt >= 2 && rt <= 5;
      if (bucket === '5plus') return rt > 5;
      return false;
    });
  }

  function matchesTags(card, tags) {
    if (!tags.length) return true;
    var cardTags = getCardTags(card);
    return tags.some(function (t) { return cardTags.indexOf(String(t).toLowerCase()) >= 0; });
  }

  function sortedCards(cards, sortKey, order) {
    var sorted = cards.slice();
    if (sortKey === 'newest') {
      sorted.sort(function (a, b) {
        return parseCardDate(b) - parseCardDate(a);
      });
    } else if (sortKey === 'oldest') {
      sorted.sort(function (a, b) {
        return parseCardDate(a) - parseCardDate(b);
      });
    } else if (sortKey === 'popular') {
      sorted.sort(function (a, b) {
        return parseInt(b.dataset.comments, 10) - parseInt(a.dataset.comments, 10);
      });
    } else if (sortKey === 'views' || sortKey === 'recommended') {
      sorted.sort(function (a, b) {
        return order.indexOf(a) - order.indexOf(b);
      });
    } else {
      sorted.sort(function (a, b) {
        var ai = parseInt(a.dataset.index, 10);
        var bi = parseInt(b.dataset.index, 10);
        if (!isNaN(ai) && !isNaN(bi)) return ai - bi;
        return order.indexOf(a) - order.indexOf(b);
      });
    }
    return sorted;
  }

  function setCardVisible(card, show) {
    card.hidden = !show;
    if (show) {
      card.classList.remove('is-filtering-out');
    } else {
      card.classList.add('is-filtering-out');
      setTimeout(function () {
        card.classList.remove('is-filtering-out');
      }, 180);
    }
  }

  function getLabelForValue(groupName, value) {
    var group = root.querySelector('[data-c27-bloglist-filter-group="' + groupName + '"]');
    if (!group) return value;
    var opt = group.querySelector('.c27-bloglist-m__filter-option[data-filter-value="' + CSS.escape(value) + '"]');
    if (opt) {
      var textEl = opt.querySelector('.c27-bloglist-m__filter-option-text');
      if (textEl) return textEl.textContent.trim();
    }
    return value;
  }

  function readCheckedValues(groupName) {
    var group = root.querySelector('[data-c27-bloglist-filter-group="' + groupName + '"]');
    if (!group) return [];
    if (groupName === 'category') {
      var allOpt = group.querySelector('.c27-bloglist-m__filter-option[data-filter-value=""]');
      var allBox = allOpt ? allOpt.querySelector('[data-c27-bloglist-checkbox]') : null;
      if (allBox && allBox.classList.contains('is-checked')) return [];
    }
    var values = [];
    group.querySelectorAll('.c27-bloglist-m__filter-option').forEach(function (opt) {
      var box = opt.querySelector('[data-c27-bloglist-checkbox]');
      var val = opt.getAttribute('data-filter-value');
      if (box && box.classList.contains('is-checked') && val) {
        values.push(val);
      }
    });
    return values;
  }

  function setFilterUI(categories, readtimes, tags) {
    root.querySelectorAll('[data-c27-bloglist-filter-group]').forEach(function (group) {
      var groupName = group.getAttribute('data-c27-bloglist-filter-group');
      var active = [];
      if (groupName === 'category') active = categories.slice();
      if (groupName === 'readtime') active = readtimes.slice();
      if (groupName === 'tags') active = tags.slice();

      group.querySelectorAll('.c27-bloglist-m__filter-option').forEach(function (opt) {
        var box = opt.querySelector('[data-c27-bloglist-checkbox]');
        var val = opt.getAttribute('data-filter-value');
        if (!box) return;
        if (groupName === 'category' && val === '') {
          box.classList.toggle('is-checked', !active.length);
        } else {
          box.classList.toggle('is-checked', active.indexOf(val) >= 0);
        }
      });
    });
  }

  function applyResults(options) {
    if (!grid || !isMobile()) return;

    var opts = options || {};
    var sorted = sortedCards(allCards, state.sort, originalOrder);
    var visibleCount = 0;

    sorted.forEach(function (card) {
      var matches =
        matchesQuery(card, state.query) &&
        matchesReadtime(card, state.readtimes) &&
        matchesTags(card, state.tags) &&
        cardMatchesCategory(card, state.categories);
      setCardVisible(card, matches);
      if (matches) visibleCount++;
    });

    sorted.forEach(function (card) {
      grid.appendChild(card);
    });

    if (globalEmpty) {
      globalEmpty.hidden = !(isFilterActive() && visibleCount === 0);
    }

    renderChips();
  }

  function renderChips() {
    if (!chipsContainer || !filteredBlock) return;
    chipsContainer.innerHTML = '';
    var chips = [];

    if (state.query) {
      chips.push({ type: 'search', value: state.query, label: state.query });
    }
    state.categories.forEach(function (value) {
      chips.push({ type: 'category', value: value, label: getLabelForValue('category', value) });
    });
    state.readtimes.forEach(function (value) {
      chips.push({ type: 'readtime', value: value, label: getLabelForValue('readtime', value) });
    });
    state.tags.forEach(function (value) {
      chips.push({ type: 'tag', value: value, label: getLabelForValue('tags', value) });
    });

    chips.forEach(function (chip) {
      var el = document.createElement('span');
      el.className = 'c27-bloglist-m__chip';
      el.setAttribute('data-c27-bloglist-chip', chip.type);
      el.setAttribute('data-chip-value', chip.value);
      el.innerHTML = '<span class="c27-bloglist-m__chip-label">' + chip.label + '</span>' +
        '<button class="c27-bloglist-m__chip-close" type="button" aria-label="Remove ' + chip.label + '">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '</button>';
      chipsContainer.appendChild(el);
    });

    filteredBlock.classList.toggle('is-empty', chips.length === 0);
  }

  function resetState() {
    state.query = '';
    state.categories = [];
    state.readtimes = [];
    state.tags = [];
    state.sort = 'default';
    if (searchInput) searchInput.value = '';
    setFilterUI([], [], []);
    sortOptions.forEach(function (btn) {
      var selected = btn.getAttribute('data-value') === 'default';
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    applyResults();
  }

  function openPanel(panel, backdrop) {
    if (!panel || !backdrop) return;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    backdrop.hidden = false;
    backdrop.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
      backdrop.classList.add('is-open');
    });
  }

  function closePanel(panel, backdrop) {
    if (!panel || !backdrop) return;
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      backdrop.hidden = true;
      backdrop.setAttribute('aria-hidden', 'true');
    }
    function onEnd(e) {
      if (e.target !== panel) return;
      panel.removeEventListener('transitionend', onEnd);
      finish();
    }
    panel.addEventListener('transitionend', onEnd);
    setTimeout(finish, 300);
  }

  function syncFilterPopupTop() {
    var searchRow = root.querySelector('.c27-bloglist-m__search-row');
    var top = 140;
    if (searchRow) {
      top = Math.max(140, Math.ceil(searchRow.getBoundingClientRect().bottom));
    }
    root.style.setProperty('--c27-m-filter-top', top + 'px');
  }

  function openFilter() {
    if (!isMobile()) return;
    if (sortSheet && !sortSheet.hidden) closePanel(sortSheet, sortBackdrop);
    syncFilterPopupTop();
    setFilterUI(state.categories, state.readtimes, state.tags);
    openPanel(filterPopup, filterBackdrop);
  }

  function closeFilter(restore) {
    if (restore) setFilterUI(state.categories, state.readtimes, state.tags);
    closePanel(filterPopup, filterBackdrop);
  }

  function openSort() {
    if (!isMobile()) return;
    if (filterPopup && !filterPopup.hidden) closePanel(filterPopup, filterBackdrop);
    openPanel(sortSheet, sortBackdrop);
  }

  function closeSort() {
    closePanel(sortSheet, sortBackdrop);
  }

  if (filterOpenBtn) {
    filterOpenBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openFilter();
    });
  }

  if (sortOpenBtn) {
    sortOpenBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openSort();
    });
  }

  filterCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closeFilter(true);
    });
  });

  if (filterCancelBtn) {
    filterCancelBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeFilter(true);
    });
  }

  if (filterApplyBtn) {
    filterApplyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      state.readtimes = readCheckedValues('readtime');
      state.tags = readCheckedValues('tags');
      state.categories = readCheckedValues('category');
      closeFilter(false);
      applyResults();
    });
  }

  if (filterBackdrop) {
    filterBackdrop.addEventListener('click', function () {
      closeFilter(true);
    });
  }

  if (sortBackdrop) {
    sortBackdrop.addEventListener('click', function () {
      closeSort();
    });
  }

  if (filterClearBtn) {
    filterClearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      setFilterUI([], [], []);
    });
  }

  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', function (e) {
      e.preventDefault();
      resetState();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      state.query = searchInput.value.trim();
      clearTimeout(filterTimer);
      filterTimer = setTimeout(applyResults, 200);
    });
  }

  root.querySelectorAll('[data-c27-bloglist-filter-group]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var opt = e.target.closest('.c27-bloglist-m__filter-option');
      if (!opt) return;
      var box = opt.querySelector('[data-c27-bloglist-checkbox]');
      if (!box) return;
      var groupName = group.getAttribute('data-c27-bloglist-filter-group');
      var filterValue = opt.getAttribute('data-filter-value');
      var isAll = groupName === 'category' && filterValue === '';

      if (isAll) {
        group.querySelectorAll('[data-c27-bloglist-checkbox]').forEach(function (b) {
          b.classList.remove('is-checked');
        });
        box.classList.add('is-checked');
      } else if (groupName === 'category') {
        group.querySelectorAll('.c27-bloglist-m__filter-option').forEach(function (item) {
          if (item.getAttribute('data-filter-value') === '') {
            var allBox = item.querySelector('[data-c27-bloglist-checkbox]');
            if (allBox) allBox.classList.remove('is-checked');
          }
        });
        box.classList.toggle('is-checked');
      } else {
        box.classList.toggle('is-checked');
      }
    });
  });

  sortOptions.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-value') || 'default';
      state.sort = value;
      sortOptions.forEach(function (b) {
        var selected = b === btn;
        b.classList.toggle('is-selected', selected);
        b.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      closeSort();
      applyResults();
    });
  });

  if (chipsContainer) {
    chipsContainer.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('.c27-bloglist-m__chip-close');
      if (!closeBtn) return;
      var chip = closeBtn.closest('[data-c27-bloglist-chip]');
      if (!chip) return;
      var type = chip.getAttribute('data-c27-bloglist-chip');
      var value = chip.getAttribute('data-chip-value');
      if (type === 'search') {
        state.query = '';
        if (searchInput) searchInput.value = '';
      } else if (type === 'category') {
        state.categories = state.categories.filter(function (v) { return v !== value; });
        setFilterUI(state.categories, state.readtimes, state.tags);
      } else if (type === 'readtime') {
        state.readtimes = state.readtimes.filter(function (v) { return v !== value; });
        setFilterUI(state.categories, state.readtimes, state.tags);
      } else if (type === 'tag') {
        state.tags = state.tags.filter(function (v) { return v !== value; });
        setFilterUI(state.categories, state.readtimes, state.tags);
      }
      applyResults();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (filterPopup && !filterPopup.hidden) closeFilter(true);
    if (sortSheet && !sortSheet.hidden) closeSort();
  });

  window.addEventListener('resize', function () {
    if (filterPopup && !filterPopup.hidden) syncFilterPopupTop();
  });

  setFilterUI(state.categories, state.readtimes, state.tags);
  applyResults();

  var visibleAfterInit = allCards.filter(function (card) { return !card.hidden; }).length;
  root.setAttribute('data-c27-bloglist-cards-before', String(cardsBeforeInit));
  root.setAttribute('data-c27-bloglist-cards-after', String(visibleAfterInit));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
